export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6h-38e0986a2b81b49704df07742708f8cc.webp";